import { GoabButton } from '@abgov/angular-components';
import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import {
  FeedbackMessageComponent,
  IconType,
} from '../feedback-message/feedback-message.component';

@Component({
  selector: 'app-feedback-with-go-home',
  imports: [CommonModule, FeedbackMessageComponent, GoabButton],
  templateUrl: './feedback-with-go-home.component.html',
  styleUrl: './feedback-with-go-home.component.scss',
})
export class FeedbackWithGoHomeComponent {
  iconType = input.required<IconType>();
  title = input.required<string>();
  subtitle = input<string>('');
  textLines = input<string[]>([]);
  router = inject(Router);
  onClick = () => {
    this.router.navigate(['/']);
  };
}
